import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { filter, map, take } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { APP_ROUTES } from '@core/constants/route.constant';

export const nonAuthGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.userProfile$.pipe(
    filter((profile) => profile !== undefined),
    take(1),
    map((profile) =>
      profile
        ? router.createUrlTree([APP_ROUTES.ADMIN.ROOT, APP_ROUTES.ADMIN.DASHBOARD])
        : true,
    ),
  );
};
